import React, { useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { store } from "react-notifications-component"
import { Route, useHistory, useRouteMatch } from "react-router"
import { notificationOptions } from "../../../api/Definitions"
import Loader from "../../../components/Loader/Loader"
import { iSpace } from "../../../definitions/Space"
import { post } from "../../../store/data/actions"
import SpaceHeader from "../Header"
import SpaceAbout from "../inspector/About"
import SpaceOverview from "../inspector/Overview"
import SpaceUploads from "../inspector/Uploads"

const CreateSpace = () => {
  const [isLoading, setLoading] = useState(false)
  const history = useHistory()
  const match = useRouteMatch()
  const methods = useForm({ shouldUnregister: false })

  const onSubmit = (data: iSpace) => {
    setLoading(true)
    post<iSpace>({ link: "/v1/create-space", data }).then((space) => {
      setLoading(false)
      history.push("/spaces/" + space.url)
      store.addNotification({
        title: "Success!",
        message: "Space successfully created!",
        type: "success",
        ...notificationOptions,
      })
    })
  }

  return (
    <FormProvider {...methods}>
      <SpaceHeader
        title="Create Space"
        submitDeleteText="Delete"
        submitText={"Create"}
        handleDelete={() => {
          console.log()
        }}
        handleSubmit={() => {
          methods.handleSubmit((data) => {
            onSubmit(data as iSpace)
          })()
        }}
        isLoading={isLoading}
      />
      <div className="inspector">
        {isLoading ? (
          <Loader />
        ) : (
          <form
            onSubmit={methods.handleSubmit((data) => {
              onSubmit(data as iSpace)
            })}
            className="inspector-form"
          >
            <Route exact path={match.path}>
              <SpaceOverview />
            </Route>
            <Route exact path={match.path + "/about"}>
              <SpaceAbout />
            </Route>
            <Route exact path={match.path + "/manage-files"}>
              <SpaceUploads />
            </Route>
            <button className="d-none" type="submit">
              Submit
            </button>
          </form>
        )}
      </div>
    </FormProvider>
  )
}

export default CreateSpace
